// src/components/ProductDetail/ProductImageModal.tsx

import { useEffect } from "react"

type Props = {
    open: boolean
    images: string[]
    activeIndex: number
    onClose: () => void
    onChange: (index: number) => void
}

export default function ProductImageModal({
    open,
    images,
    activeIndex,
    onClose,
    onChange,
}: Props) {

    // ESC + ← →
    useEffect(() => {
        if (!open) return

        const handler = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose()
            if (e.key === "ArrowLeft") onChange(Math.max(0, activeIndex - 1))
            if (e.key === "ArrowRight") onChange(Math.min(images.length - 1, activeIndex + 1))
        }

        document.addEventListener("keydown", handler)
        return () => document.removeEventListener("keydown", handler)
    }, [open, activeIndex])

    if (!open) return null

    return (
        <div
            role="presentation"
            aria-labelledby="image-gallery-title"
            aria-describedby="image-gallery-description"
            style={{ position: "fixed", zIndex: 1300, inset: 0 }}
        >
            {/* BACKDROP */}
            <div className="MuiBackdrop-root" aria-hidden="true" onClick={onClose} />

            {/* MODAL */}
            <div
                className="jss219"
                tabIndex={-1}
                style={{
                    opacity: 1,
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }}
            >
                {/* CLOSE */}
                <div className="styles_closeWrapper__uCKj0">
                    <button onClick={onClose} className="MuiButtonBase-root MuiIconButton-root" tabIndex={0} type="button" aria-label="close" style={{ height: "18px", width: "18px" }}><span className="MuiIconButton-label"><svg className="MuiSvgIcon-root jss221" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg></span><span className="MuiTouchRipple-root"></span></button>
                </div>

                <div>
                    <div className="MuiGrid-root MuiGrid-container grid-full-1199">

                        {/* LEFT IMAGE */}
                        <div className="MuiGrid-root MuiGrid-item">
                            <div className="styles_wrapperImg__PDDk2">

                                {/* PREV */}
                                <button
                                    onClick={() => onChange(Math.max(0, activeIndex - 1))}
                                    className="MuiButtonBase-root MuiIconButton-root jss223"
                                    tabIndex={0}
                                    type="button"
                                    aria-label="prev"
                                    style={{ left: "40px", zIndex: 10 }}
                                >
                                    <span className="MuiIconButton-label">
                                        <svg className="MuiSvgIcon-root jss224" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                                        </svg>
                                    </span>
                                    <span className="MuiTouchRipple-root"></span>
                                </button>

                                {/* MAIN IMAGE */}
                                <img
                                    src={images[activeIndex]}
                                    alt=""
                                    className="styles_imageMain__spbIb w-full h-full"
                                />

                                {/* NEXT */}
                                <button
                                    onClick={() => onChange(Math.min(images.length - 1, activeIndex + 1))}
                                    className="MuiButtonBase-root MuiIconButton-root jss223  lg:left-[590px] right-[40px] left-auto"
                                    tabIndex={0}
                                    type="button"
                                    aria-label="next"
                                    style={{ zIndex: 10 }}
                                >
                                    <span className="MuiIconButton-label">
                                        <svg className="MuiSvgIcon-root jss224" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                                        </svg>
                                    </span>
                                    <span className="MuiTouchRipple-root"></span>
                                </button>
                            </div>
                        </div>

                        {/* RIGHT THUMB LIST */}
                        <div
                            className="MuiGrid-root MuiGrid-item !w-full lg:!w-[250px] lg:ml-[50px] p-4 lg:p-0"
                        >
                            <p className="MuiTypography-root styles_imageNameText__9IHtY MuiTypography-body1">
                                Cồn 90 độ direh perfect havico (c/1000ml)
                            </p>

                            <div className="styles_wrapper_thumbnail__oQiOk">
                                {images.map((img, idx) => (
                                    <button
                                        key={idx}
                                        className={`MuiButtonBase-root styles_thumbnail_image_wrapper__h4gYD ${idx === activeIndex
                                            ? "styles_thumbnail_selected__RBkuM"
                                            : ""
                                            }`}
                                        type="button"
                                        onClick={() => onChange(idx)}
                                    >
                                        <img src={img} alt="" />
                                    </button>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
